import { render, staticRenderFns } from "./BeeswarmWrapper.vue?vue&type=template&id=6a73430e&"
import script from "./BeeswarmWrapper.vue?vue&type=script&lang=js&"
export * from "./BeeswarmWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports